<template>
  <PMain v-model="themeData" :dataKey="key">
    <v-container class="my-order">
      <v-card
        flat
        :loading="isLoading"
        v-if="
          order &&
          themeData.myOrder &&
          themeData.myOrder.data &&
          themeData.myOrder.data.active &&
          themeData.myOrder.data.attr
        "
        v-bind="themeData.myOrder.data.attr"
      >
        <v-card-text v-bind="themeData.myOrder.data.nodes.content.data.attr">
          <table
            :style="{
              backgroundColor:
                themeData.myOrder.data.nodes.content.data.attr.backgroundColor,
              color: themeData.myOrder.data.nodes.content.data.attr.color,
            }"
            width="100%"
          >
            <tbody>
              <tr>
                <th width="25%" style="text-align: left">{{ $t('order.order') }}</th>
                <td>: #{{ order.daily_order_number }}</td>
                <th width="25%" style="text-align: left">{{ $t('order.totalRound') }}</th>
                <td>: {{ order.order_rounds.length }}</td>
              </tr>
              <tr>
                <th width="25%" style="text-align: left">{{ $t('order.table') }}</th>
                <td>
                  :
                  {{ order.table ? order.table.number : "-" }}
                </td>
                <th width="25%" style="text-align: left">{{ $t('order.totalPrice') }}</th>
                <td>: {{ $store.getters['theme/getIsCurrencyShownAtOrder'] ? $store.getters['theme/getCurrencySymbol'] : '' }}{{ getGrandTotalPrice | formatDecimal }}</td>
              </tr>
              <!-- 
              <tr>
                <th width="25%" style="text-align: left">Can Order</th>
                <td>: {{ sessionData.is_blocked ? 'No'  : 'Yes'}}</td>
                <th colspan="2"></th>
              </tr> -->

              <tr>
                <th width="25%" style="text-align: left">{{ $t('order.paymentStatus') }}</th>
                <td>: {{ order.is_paid ? $t('order.paid') : $t('order.unpaid') }}</td>
                <th width="25%" style="text-align: left" colspan="2"></th>
              </tr>
            </tbody>
          </table>

          <div
            v-if="
              themeData &&
              themeData.payNowButton &&
              themeData.payNowButton.data.active
            "
          >
            <PButton
              v-model="themeData.payNowButton.data"
              v-if="!order.is_paid"
              @click="$router.push('/payment-order')"
            />
          </div>

          <v-expansion-panels
            v-bind="themeData.myOrder.data.nodes.round.data.attr"
          >
            <v-expansion-panel
              v-for="(round, idx) in order.order_rounds"
              :key="idx"
              :style="{
                backgroundColor:
                  themeData.myOrder.data.nodes.round.data.attr.backgroundColor,
                color: themeData.myOrder.data.nodes.round.data.attr.color,
              }"
            >
              <v-expansion-panel-header
                :style="{
                  backgroundColor:
                    themeData.myOrder.data.nodes.roundHeader.data.attr
                      .backgroundColor,
                  color:
                    themeData.myOrder.data.nodes.roundHeader.data.attr.color,
                }"
              >
                {{
                  round.round_number
                    ? $t('order.round') + " " + round.round_number
                    : "Free " + $t('order.round')
                }}
                <!-- - {{ round.order.order_status.name }} -->
                <v-spacer />
                <!-- {{ sessionData.order.total_price | formatDecimal }} -->
              </v-expansion-panel-header>
              <v-expansion-panel-content
                :color="
                  themeData.myOrder.data.nodes.roundContent.data.attr.color
                "
              >
                <table
                  :style="{
                    backgroundColor:
                      themeData.myOrder.data.nodes.roundContent.data.attr
                        .backgroundColor,
                    color:
                      themeData.myOrder.data.nodes.roundContent.data.attr.color,
                  }"
                  width="100%"
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                >
                  <thead>
                    <tr>
                      <th style="text-align: left" width="50%">
                        {{ $t('order.item') }}
                        {{
                          themeData.myOrder.data.nodes.roundContent.data.attr
                            .color
                        }}
                      </th>
                      <th style="text-align: right" width="25%">{{ $t('order.qty') }}</th>
                      <th style="text-align: right" width="25%">{{ $t('order.total') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(product, i) in round.products" :key="i">
                      <td>
                        <div v-if="product.parent_id == null">
                          <div style="font-weight: bold">
                            {{ product.product_detail.name }}
                          </div>
                          <small v-if="product.remarks"
                            >&nbsp;&nbsp;<i>{{ product.remarks }}</i></small
                          >
                        </div>
                        <div v-else>
                          &nbsp;&nbsp;&raquo;&nbsp;&nbsp;{{
                            product.product_detail.name
                          }}
                        </div>
                      </td>
                      <td style="text-align: right">
                        <div>{{ product.quantity }}</div>
                      </td>
                      <td style="text-align: right">
                        <div>{{ $store.getters['theme/getIsCurrencyShownAtOrder'] ? $store.getters['theme/getCurrencySymbol'] : '' }}{{ product.total_price | formatDecimal }}</div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot v-if="order && order.order_remark">
                    <tr>
                      <td colspan="3">
                        <small
                          >Remark:
                          <p>
                            {{ order.order_remark }}
                          </p>
                        </small>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>

      </v-card>
      <v-row v-else>
        <v-col>
          <v-skeleton-loader
            v-if="isLoading"
            type="card"
          ></v-skeleton-loader>
          <v-col v-else> {{ $t('order.noOrderFound') }} </v-col>
        </v-col>
      </v-row>
    </v-container>
  </PMain>
</template>

<script>
import { mapState, mapActions } from "vuex";
import PMain from "../components/PMain.vue";
import PButton from "../components/_render/PButton.vue";

export default {
  components: {
    PMain,
    PButton,
  },
  props: {
    value: Boolean,
  },
  async mounted() {
    this.isLoading = true;
    // if (this.sessionData && this.sessionData.uniq_id) {
    //   await this.getSession(this.sessionData.uniq_id);
    // }
    if (this.order && this.order.id) {
      await this.getOrder(this.order.id);
    }
    this.isLoading = false;
  },
  data() {
    return {
      key: "myOrder",
      themeData: {},
      themeDataCart: {},
      innerValue: this.value,
      isLoading: false,
      timer: null,
      remainSecond: null,
    };
  },
  filters: {
    formatDecimal(value) {
      return parseFloat(value).toFixed(2);
    },
    formatSecondToMin(value) {
      return value > 0
        ? "Will be expired in " + Math.round(value / 60) + " mins "
        : "Expired";
    },
  },
  methods: {
    ...mapActions({
      getSession: "session/getByUniqId",
      getOrder: "cart/getOrderById",
    }),
    applyColor(newValue) {
      document.body.style.setProperty(
        "--roundHeaderBackgroundColor",
        newValue.myOrder.data.nodes.roundHeader.data.attr.style.backgroundColor
      );
      document.body.style.setProperty(
        "--roundHeaderColor",
        newValue.myOrder.data.nodes.roundHeader.data.attr.style.color
      );
      document.body.style.setProperty(
        "--roundHeaderFontFamily",
        newValue.myOrder.data.nodes.roundHeader.data.attr.style.fontFamily
      );
      document.body.style.setProperty(
        "--roundHeaderFontSize",
        newValue.myOrder.data.nodes.roundHeader.data.attr.style.fontSize
      );

      document.body.style.setProperty(
        "--roundContentBackgroundColor",
        newValue.myOrder.data.nodes.roundContent.data.attr.style.backgroundColor
      );
      document.body.style.setProperty(
        "--roundContentColor",
        newValue.myOrder.data.nodes.roundContent.data.attr.style.color
      );
      document.body.style.setProperty(
        "--roundContentFontFamily",
        newValue.myOrder.data.nodes.roundContent.data.attr.style.fontFamily
      );
      document.body.style.setProperty(
        "--roundContentFontSize",
        newValue.myOrder.data.nodes.roundContent.data.attr.style.fontSize
      );
    },
  },
  watch: {
    innerValue(newValue) {
      this.$emit("input", newValue);
    },
    async value(newValue) {
      this.innerValue = newValue;

      if (newValue) {
        await this.getOrder(this.order.id);
      }
    },
    themeData: {
      handler(newValue) {
        this.applyColor(newValue);
      },
      deep: true,
    },
    themeCart: {
      handler(newValue) {
        this.themeDataCart = newValue;
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      // sessionData: (state) => state.session.data,
      cartData: (state) => state.cart,
      tableList: (state) => state.table.data,
      order: (state) => state.cart.order,
    }),
    themeCart() {
      return this.$store.getters["theme/cart"];
    },
    getGrandTotalPrice() {
      return this.order ? this.order.total_price : 0;
    },
    getTableName() {
      const foundTable = this.tableList.filter(
        (item) => item.id == this.cartData.tableId
      );

      let tableName = [];

      if (foundTable.length !== 0) {
        const tableDetail = foundTable[0];

        if (tableDetail.table_group) {
          tableName.push(tableDetail.table_group.name);
        }

        tableName.push(tableDetail.name);
      }
      return tableName.join(" / ");
    },
  },
};
</script>

<style>
.my-order .v-expansion-panel {
  background-color: var(--roundHeaderBackgroundColor, #1b1b1b) !important;
  color: var(--roundHeaderColor, #1b1b1b) !important;
  font-size: var(--roundHeaderFontSize, #1b1b1b) !important;
}

.my-order .v-expansion-panel-content {
  background-color: var(--roundContentBackgroundColor, #1b1b1b) !important;
  color: var(--roundContentColor, #1b1b1b) !important;
  font-size: var(--roundContentFontSize, #1b1b1b) !important;
}

.my-order .v-expansion-panel-content table {
  border: 0px;
  padding: 0px;
}

.my-order .v-expansion-panel-content th {
  border-bottom: 1px solid var(--roundHeaderBackgroundColor, #1b1b1b) !important;
  padding: 8px 0px;
  margin-bottom: 5px;
}
</style>
